import { IcLookupCostUnitTypeItemDto } from '@data-access/bulk-operations-api';

import { IcCostUnitType, IcCostUnitTypesService } from '../services/ic-cost-unit-types.service';
import { createIcServiceMock } from './item-cache-service.base.mock';

const icCostUnitTypes: IcLookupCostUnitTypeItemDto[] = [
  IcLookupCostUnitTypeItemDto.fromJS({
    data: {
      name: 'Name CU #1',
      hasMore: false,
    },
    id: 'id-cu-1',
  }),
  IcLookupCostUnitTypeItemDto.fromJS({
    data: {
      name: 'Name CU #2',
      hasMore: false,
    },
    id: 'id-cu-2',
  }),
];

// Should be synced with mapper in the service
function mapToLookupModel(value: IcLookupCostUnitTypeItemDto): IcCostUnitType {
  return {
    ...value.data,
    id: value.id,
    displayName: `${value.id} - ${value.data.name}`,
  };
}

export function getIcCostUnitTypesServiceMock() {
  const mappedTypes = icCostUnitTypes.map(mapToLookupModel);
  const baseMock = createIcServiceMock(mappedTypes, icCostUnitTypes);

  const typesMap = new Map(mappedTypes.map((type) => [type.id, type]));

  return {
    ...baseMock,
    getActiveCostUnitTypesForDateRange: (
      _dateFrom: Date,
      _dateTo: Date | null,
    ): IcCostUnitType[] => {
      return mappedTypes;
    },
    getActiveCostUnitTypesForDateMap: (_dateFrom: Date, _dateTo: Date | null = null) => {
      return typesMap;
    },
  } as Partial<IcCostUnitTypesService>;
}
